import type { Cards } from '../../../../common/types.tsx';
import {
	TAILORED_ONBOARDING_SUMMARY,
	TAILORED_ONBOARDING_LIST,
	TAILORED_ONBOARDING_TIMELINE,
	TAILORED_ONBOARDING_PAGES,
	TAILORED_ONBOARDING_FORM,
	TAILORED_ONBOARDING_INVITE,
	TAILORED_ONBOARDING_BOARD,
	TAILORED_ONBOARDING_CALENDAR,
	TAILORED_ONBOARDING_CODE,
	TAILORED_ONBOARDING_BACKLOG,
} from '../../../../common/constants.tsx';
import { Experiment } from '../jsw/constants.tsx';
import { Feature, TeamType } from './constants.tsx';

export const TAILORED_ONBOARDING_SINGLE_CONFIG: Cards = {
	[TAILORED_ONBOARDING_SUMMARY]: {
		position: {
			default: 200,
			conditional: [
				{
					condition: [TeamType.marketing],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: false,
				},
				{
					condition: [TeamType.marketing],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_TIMELINE]: {
		position: {
			default: 0,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 600,
				},
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 500,
				},
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
					],
					value: 600,
				},
				{
					condition: [TeamType.marketing],
					value: 100,
				},
				{
					condition: [TeamType.productManagement],
					value: 200,
				},
				{
					condition: [TeamType.projectManagement],
					value: 100,
				},
				{
					condition: [TeamType.software],
					value: 400,
				},
				{
					condition: [TeamType.operations],
					value: 300,
				},
				{
					condition: [TeamType.everythingElse],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [TeamType.marketing],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_LIST]: {
		position: {
			default: 0,
			conditional: [],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: false,
				},
				{
					condition: [TeamType.marketing],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_BACKLOG]: {
		position: { default: 0 },
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_BOARD]: {
		position: {
			default: 100,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 100,
				},
				{
					condition: [TeamType.design],
					value: 400,
				},
				{
					condition: [TeamType.itSupport],
					value: 300,
				},
				{
					condition: [TeamType.operations],
					value: 100,
				},
				{
					condition: [TeamType.everythingElse],
					value: 100,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_CALENDAR]: {
		position: {
			default: 300,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 300,
				},
				{
					condition: [TeamType.marketing],
					value: 100,
				},
				{
					condition: [TeamType.productManagement],
					value: 300,
				},
				{
					condition: [TeamType.projectManagement],
					value: 300,
				},
				{
					condition: [TeamType.software],
					value: 200,
				},
				{
					condition: [TeamType.itSupport],
					value: 500,
				},
				{
					condition: [TeamType.operations],
					value: 400,
				},
				{
					condition: [TeamType.everythingElse],
					value: 200,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: false,
				},
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
					],
					value: false,
				},
				{
					condition: [TeamType.marketing],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_CODE]: {
		position: {
			default: 300,
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
					],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_PAGES]: {
		position: {
			default: 300,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						TeamType.software,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 400,
				},
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 500,
				},
				{
					condition: [TeamType.projectManagement],
					value: 500,
				},
				{
					condition: [TeamType.software],
					value: 500,
				},
				{
					condition: [TeamType.itSupport],
					value: 500,
				},
				{
					condition: [TeamType.everythingElse],
					value: 500,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [TeamType.marketing],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: false,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_FORM]: {
		position: {
			default: 500,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 500,
				},
				{
					condition: [TeamType.marketing],
					value: 400,
				},
				{
					condition: [TeamType.design],
					value: 300,
				},
				{
					condition: [TeamType.productManagement],
					value: 300,
				},
				{
					condition: [TeamType.projectManagement],
					value: 300,
				},
				{
					condition: [TeamType.itSupport],
					value: 400,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
	[TAILORED_ONBOARDING_INVITE]: {
		position: {
			default: 500,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: 700,
				},
				{
					condition: [
						TeamType.software,
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
					],
					value: 700,
				},
			],
		},
		visibility: {
			default: false,
			conditional: [
				{
					condition: [
						Experiment.tailoredOnboardingScrumAndSoftwareKanbanEligible,
						Feature.hasBacklog,
						Feature.hasSprint,
					],
					value: true,
				},
				{
					condition: [TeamType.marketing],
					value: true,
				},
				{
					condition: [TeamType.design],
					value: true,
				},
				{
					condition: [TeamType.productManagement],
					value: true,
				},
				{
					condition: [TeamType.projectManagement],
					value: true,
				},
				{
					condition: [TeamType.software],
					value: true,
				},
				{
					condition: [TeamType.otherPersonal],
					value: true,
				},
				{
					condition: [TeamType.itSupport],
					value: true,
				},
				{
					condition: [TeamType.operations],
					value: true,
				},
				{
					condition: [TeamType.everythingElse],
					value: true,
				},
			],
		},
	},
};
